import produce from 'immer';
import create from 'zustand';

const useStore = create(set => ({
  hasLatestWires: false,
  hasMentions: false,
  set: fn => set(produce(fn)),
}));

export default useStore;
